module.exports = {

  default: { click: { dest: 'clientActivity', elem: 'page', act: 'show', id: `clientActivity-page`, leftnav: 'leftnav-clientActivity-page', from: 'leftnav' }, },

  //-------------------------------------------------------------------------------------------------------------------------------------
  clientActivity: {
    mainPage: true,
    activePage: '',
    click: { dest: 'clientActivity', elem: 'page', act: 'show', id: `clientActivity-page`, leftnav: 'leftnav-clientActivity-page', from: 'leftnav' },
  },

}